import { createFileRoute } from '@tanstack/react-router'
import DashboardDadosPage from '@/pages/dashboard/dashboard-dados-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/dados',
)({
  component: function DadosRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <DashboardDadosPage />
      </ProtectedRoute>
    )
  },
})
